import React from 'react';

import PropTypes from 'prop-types';

import { WEATHER_TILES } from 'consts/mapConfig';
import { getWindowDimensions } from 'components/alert/AlertScreenResolution';
import { useStyles } from './MapLegendUseStyles';

const MapLegend = props => {
  const { weatherLayer, legendName } = props;
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions().width
  );

  React.useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions().width);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const widthStyles = {
    width: windowDimensions,
  };
  const classes = useStyles(widthStyles);

  const returnWeatherBar = (weatherLayerCase, legendNameToDisplay) => {
    switch (weatherLayerCase) {
      case WEATHER_TILES.temperature:
        return (
          <>
            <div
              className={`${classes.MapLegend}__wrapper  ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
            >
              {legendNameToDisplay} &#8451;
            </div>
            <div className={`${classes.MapLegend}__scale__gradient`}>
              <div
                className={`${classes.MapLegend}__scale__gradient__dividers ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
              >
                <div>-40</div>
                <div>-20</div>
                <div>0</div>
                <div>20</div>
                <div>40</div>
              </div>
              <div
                className={`${classes.MapLegend}__wrapper__weather ${classes.MapLegendCalc}__wrapper__weather ${classes.MapLegend}__wrapper__weather__temperature--background-image`}
              ></div>
            </div>
          </>
        );
      case WEATHER_TILES.clouds:
        return (
          <>
            <div
              className={`${classes.MapLegend}__wrapper ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
            >
              {`${legendNameToDisplay}`}
            </div>
            <div className={`${classes.MapLegend}__scale__gradient`}>
              <div
                className={`${classes.MapLegend}__scale__gradient__dividers ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
              >
                <div>0</div>
                <div>25</div>
                <div>50</div>
                <div>75</div>
                <div>100</div>
              </div>
              <div
                className={`${classes.MapLegend}__wrapper__weather ${classes.MapLegendCalc}__wrapper__weather ${classes.MapLegend}__wrapper__weather__clouds--background-image`}
              ></div>
            </div>
          </>
        );
      case WEATHER_TILES.pressure:
        return (
          <>
            <div
              className={`${classes.MapLegend}__wrapper ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
            >
              {legendNameToDisplay}
            </div>
            <div className={`${classes.MapLegend}__scale__gradient`}>
              <div
                className={`${classes.MapLegend}__scale__gradient__dividers ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
              >
                <div>950</div>
                <div>980</div>
                <div>1010</div>
                <div>1040</div>
                <div>1070</div>
              </div>
              <div
                className={`${classes.MapLegend}__wrapper__weather ${classes.MapLegendCalc}__wrapper__weather ${classes.MapLegend}__wrapper__weather__pressure--background-image`}
              ></div>
            </div>
          </>
        );
      case WEATHER_TILES.wind:
        return (
          <>
            <div
              className={`${classes.MapLegend}__wrapper ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
            >
              {legendNameToDisplay}
            </div>
            <div className={`${classes.MapLegend}__scale__gradient`}>
              <div
                className={`${classes.MapLegend}__scale__gradient__dividers ${classes.MapLegend}--font-size ${classes.MapLegend}__text--color`}
              >
                <div>0</div>
                <div>2</div>
                <div>3</div>
                <div>6</div>
                <div>12</div>
                <div>25</div>
                <div>50</div>
                <div>100</div>
              </div>
              <div
                className={`${classes.MapLegend}__wrapper__weather ${classes.MapLegendCalc}__wrapper__weather ${classes.MapLegend}__wrapper__weather__wind--background-image`}
              ></div>
            </div>
          </>
        );
      case WEATHER_TILES.precipitation:
        return null;
      default:
        return null;
    }
  };
  return (
    <>
      {returnWeatherBar(weatherLayer, legendName) && (
        <div className={`${classes.MapLegend} ${classes.MapLegendCalc}`}>
          {returnWeatherBar(weatherLayer, legendName)}
        </div>
      )}
    </>
  );
};

MapLegend.propTypes = {
  weatherLayer: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.instanceOf(null).isRequired,
  ]),
  legendName: PropTypes.string,
};

export default MapLegend;
